import { Injectable } from "@nestjs/common";
import { LocationsEntity } from "./locations.entity";
import { LocationsDto } from "./dto/locations-dto";
import { divisionEntity } from "../division/division-entity";
@Injectable()
export class LocationsAdapter{

    /**
     * 
     * @param  LocationDto
     * @param isUpdate 
     * @returns 
     */

    public convertDtoToEntity (locDto :LocationsDto, isUpdate:boolean=false):LocationsEntity {
        const location = new LocationsEntity();
        location.locationName=locDto.locationName;
        location.address=locDto.address;
        location.unitNo=locDto.unitNo;
        location.plantId=locDto.plantId;
        let divData = new divisionEntity();
        divData.id = locDto.divisionId
        location.dpom=divData;
        location.state=locDto.state;
        location.gps=locDto.gpsLocation;
        location.isActive=locDto.isActive==undefined?true:locDto.isActive;
        if(isUpdate){
            location.id = locDto.id
            location.updatedUser=locDto.updatedUser;

        }else{

            location.isActive=true;
            location.createdUser=locDto.createdUser;
        
        }
        return location;
    }


    public convertEntityToDto (loc:LocationsEntity):LocationsDto{
        const location= new LocationsDto();
        location.locationName=loc.locationName;
        location.address=loc.address;
        location.gpsLocation=loc.gps;
        location.plantId=loc.plantId;
        location.isActive=loc.isActive;
        location.createdAt=loc.createdAt;
        location.updatedAt=loc.updatedAt;
        location.updatedUser=loc.updatedUser;
        location.versionFlag=loc.versionFlag;
        return  location;

    }

}